import initialState from './initialState';
import { HOSTING_ELEMENT_CHANGED, INIT_HOSTING_ELEMENT } from '../constants/actionTypes';

export default function (state = initialState.hostingElement, action) {
  switch (action.type) {
    case INIT_HOSTING_ELEMENT:    
    case HOSTING_ELEMENT_CHANGED:  
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

